import React from 'react';

import { useGeolocationContext } from '../hooks/geolocationContext';

import { VehicleMarker } from './VehicleMarker';

export const VehiclesMapMarkersList = () => {
	const { vehicles } = useGeolocationContext();

	return vehicles.map(vehicle => {
		if (!vehicle?.gpsDevice) return;

		return (
			<VehicleMarker key={vehicle.id} deviceVehicle={vehicle} />
		)
	});
}
